
export interface NAL {
  naluCode: number;
  data: Uint8Array
}

export function parseNalUnitsWithLengthPrefix(nalLengthSize: number, buffer: Uint8Array): NAL[] {
  const nalus: NAL[] = [];
  let pos = 0;
  while (pos < buffer.length) {
    let nBytes = 0;
    for (let i = 0; i < nalLengthSize; i++) {
      const byte = buffer[pos++];
      if (byte === undefined) {
        throw new Error(`Index out of bound: ${pos - 1} (length = ${buffer.length})`);
      }
      nBytes = 256 * nBytes + byte;
    }
    nBytes--;
    const byte = buffer[pos++];
    if (byte === undefined) {
      throw new Error(`Index out of bound: ${pos - 1} (length = ${buffer.length})`);
    }
    // eslint-disable-next-line no-bitwise
    const naluCode = byte & 0x1f;
    const data = buffer.slice(pos, pos + nBytes);
    nalus.push({
      naluCode,
    data,
    });
    pos += nBytes;
  }

  if (pos !== buffer.length) {
    throw new Error(`Expected position to be at end of buffer ${buffer.length} but got ${pos}`);
  }
  return nalus;
}
